import { createApp } from 'vue';

import VideoModal from '../components/video/videoModal.vue';

// Mounts videos rendered by templates/partials/_videoModal.twig while VideoModal stays in compat mode.
const app = createApp({
	components: {
		VideoModal
	}
});

app.config.compilerOptions.whitespace = 'preserve';
app.mount('#videoModal');
